export const findStockPrices = ({ target = undefined, page = undefined }) => ({
  type: 'FIND_STOCK_PRICES',
  target,
  page
})

export const submitContactWidget = ({
  firstName = undefined,
  lastName = undefined,
  email = undefined,
  phone = undefined,
  location = undefined,
  agreementPolicy = undefined,
  agreementMailing = undefined
}, onSuccess) => ({
  type: 'SUBMIT_CONTACT_WIDGET',
  firstName,
  lastName,
  email,
  phone,
  location,
  agreementPolicy,
  agreementMailing,
  onSuccess
})

export const resetContactWidget = () => ({
  type: 'RESET_CONTACT_WIDGET'
})

export const submitCustomContactForm = ({
  company = undefined,
  firstName = undefined,
  lastName = undefined,
  email = undefined,
  phone = undefined,
  location = undefined,
  question = undefined,
  attachments = undefined,
  agreementPolicy = undefined,
  agreementMailing = undefined,
  agreementMarketing = undefined
}, onSuccess) => ({
  type: 'SUBMIT_CUSTOM_CONTACT_FORM',
  company,
  firstName,
  lastName,
  email,
  phone,
  location,
  question,
  attachments,
  agreementPolicy,
  agreementMailing,
  agreementMarketing,
  onSuccess
})

export const resetCustomContactForm = () => ({
  type: 'RESET_CUSTOM_CONTACT_FORM'
})

export const submitNewsletterWidget = ({ email = undefined, agreementPolicy = undefined, agreementMailing = undefined, agreementMarketing = undefined }) => ({
  type: 'SUBMIT_NEWSLETTER_WIDGET',
  email,
  agreementPolicy,
  agreementMailing,
  agreementMarketing
})

export const resetNewsletterWidget = () => ({
  type: 'RESET_NEWSLETTER_WIDGET'
})



// WEBPACK FOOTER //
// ./src/custom/actions/index.js